import React, { useState, useEffect } from 'react';

const YouTubeEmbed = ({ youtubeId, thumbnail, reset, autoplay, onResetComplete, title }) => {
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (reset) {
      setIsPlaying(false);
      onResetComplete();
    } else if (autoplay) {
      setIsPlaying(true);
    }
  }, [reset, autoplay, onResetComplete]);

  const handlePlay = () => {
    setIsPlaying(true);
    dataLayer.push({
      event: 'user_guide_video_play',
      cta_text: 'Play',
      banner_name: title,
      BrandName: 'TVS iQube',
      VariantName: 'SmartXonnect',
    });
  };

  return (
    <div className="video-placeholder">
      {!isPlaying ? (
        <>
          <img src={thumbnail} alt="Video thumbnail" className="video-thumbnail" loading="lazy" />
          <div className="play-overlay" onClick={handlePlay}>
            <div className="play-button"></div>
            <div className="play-text">Play</div>
          </div>
        </>
      ) : (
        <div className="youtube-container">
          <iframe
            width="100%"
            height="100%"
            src={`https://www.youtube.com/embed/${youtubeId}?autoplay=1`}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="Embedded youtube"
          />
        </div>
      )}
    </div>
  );
};

export default React.memo(YouTubeEmbed);
